// 业务库存管理
const map = {
  qtStockinApplyOrder: () => import('@/views/businessInventoryManagement/QtStockinApplyOrder'), // 其他入库申请单
  qtStockinApplyOrderDetail: () => import('@/views/businessInventoryManagement/QtStockinApplyOrderDetail'), // 其他入库申请单详情
  qtStockoutApplyOrder: () => import('@/views/businessInventoryManagement/QtStockoutApplyOrder'), // 其他出库申请单
  qtStockoutApplyOrderDetail: () => import('@/views/businessInventoryManagement/QtStockoutApplyOrderDetail') // 其他出库申请单详情
}

export default map
